import { useMemo } from 'react';
import useSWR from 'swr';
import { exchangeAndReturnService } from 'services';
import { HistoryContent } from 'types';
import { Accordion, History, Loading, Text } from 'components';
import { addToHistoryList } from 'helpers';
import { FontSize } from 'commons';
import { ReturnHistoryContent } from '../components';
import * as S from '../styles';

interface Props {
  protocol: string;
  defaultOpen?: boolean;
}

export function ReturnHistoryAndTracking({
  protocol,
  defaultOpen = false,
}: Props) {
  const { data: historyEntries, isValidating } = useSWR(
    protocol ? `return-history-${protocol}` : null,
    () => exchangeAndReturnService.getHistory({ protocol }),
    { revalidateOnFocus: false }
  );

  const formattedList = useMemo(() => {
    if (historyEntries) {
      const historyLength = historyEntries.length;

      return historyEntries.reduce<HistoryContent[]>((acc, cur, index) => {
        const { date, type } = cur;
        const isLastEntry = historyLength === index + 1;

        const content = (
          <ReturnHistoryContent
            entry={cur}
            isDone={type === 'REFUNDED'}
            isLast={isLastEntry}
          />
        );

        return addToHistoryList({
          list: acc,
          content,
          date,
        });
      }, []);
    }

    return [];
  }, [historyEntries]);

  return (
    <Accordion
      title="Histórico e Tracking da Devolução"
      defaultOpen={defaultOpen}
    >
      <S.Main>
        <Text size={FontSize.font12}>
          Acompanhe o histórico da devolução e o status do correio. Quando o
          produto chegar confirme se era o mesmo produto cujo a devolução foi
          solicitada e confirme o recebimento.
        </Text>

        {isValidating ? (
          <Loading />
        ) : formattedList?.length ? (
          <History content={formattedList} />
        ) : (
          <p>Nenhum registro encontrado</p>
        )}
      </S.Main>
    </Accordion>
  );
}
